<template>
	<!-- <div class="page-index-mobile column-me row-center" v-if="isMobile"></div> -->
	<div ref="carouselFull" class="page-index column-me row-center">
		<div class="all">
			<toubu></toubu>
			<div class="two">
				<img src="../../assets/img/honorBanner.png" class="imgBg" />
				<div class="getBack" @click="getBack()">
					<img src="../../assets/fuwuimg/icon_weizhi.png" />
					<div>首页 > <span>荣誉资质</span></div>
				</div>
				<div class="technologyBox">
					<div class="two1">
						高新技术企业证书
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						HIGH TECH ENTERPRISE CERTIFICATE
					</div>
					<div class="technologyImg">
						<div class="cenImg">
							<el-image src="http://qiniu.boruankeji.net/6821bde60d0756f874e88648607659e1.png" :preview-src-list="technologyImg">
							</el-image>
							<!-- <div class="txt"></div> -->
						</div>
					</div>
				</div>
				<div class="technologyBox">
					<div class="two1">
						CMMI三级证书
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						CMMI LEVEL III CERTIFICATE
					</div>
					<div class="technologyImg">
						<div class="cenImg">
							<el-image src="http://qiniu.boruankeji.net/dcd68a9231fd4abda479781b54b1f076.png" :preview-src-list="CMMIImg">
							</el-image>
							<div class="txt"></div>
						</div>
					</div>
				</div>
				
				<div class="ITSSBox">
					<div class="two1">
						ITSS三级证书
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						ITSS LEVEL III CERTIFICATE
					</div>
					<div class="ITSSImg">
						<div class="cenImg cenImgone">
							<el-image src="http://qiniu.boruankeji.net/2b23e38799cf5036b730b474ad8a64dd.png" :preview-src-list="ITSSImg">
							</el-image>
							<!-- <div class="txt"></div> -->
						</div>
						<div class="cenImg">
							<el-image src="http://qiniu.boruankeji.net/369c919d1c5ee7295bfbeca5a9dce6a7.png" :preview-src-list="ITSSImg">
							</el-image>
							<!-- <div class="txt"></div> -->
						</div>
					</div>
				</div>
				
				<div class="ISOBox">
					<div class="two1">
						ISO20000/ISO27001证书
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						ISO20000/ISO27001 CERTIFICATE
					</div>
					<div class="ISOImg">
						<div class="cenImg cenImgone">
							<el-image src="http://qiniu.boruankeji.net/b52f7c8f78d6895216231a1a897cf331.png" :preview-src-list="ISOImg">
							</el-image>
							<div class="txt">信息技术服务管理体系 认证证书</div>
						</div>
						<div class="cenImg">
							<el-image src="http://qiniu.boruankeji.net/67adb94bcaee4146182dbf5e4fddc251.png" :preview-src-list="ISOImg">
							</el-image>
							<div class="txt">信息安全管理体系 认证证书</div>
						</div>
					</div>
				</div>
				
				
				<div class="managementBox" v-if="srcList.length >0">
					<div class="two1">
						管理体系认证
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						MANAGEMENT SYSTEM CERTIFICATION
					</div>
					<div class="managementImg">
						<div class="cenImg" v-for="i in srcList" :key="i.id">
							<el-image :src="i.img" :preview-src-list="Img">
							</el-image>
							<div class="txt">{{i.title}}</div>
						</div>
					</div>
				</div>
				<div class="certificateBox" v-if="third_aList.length >0">
					<div class="two1">
						3A证书
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						3A CERTIFICATE
					</div>
					<div class="certificateImg">
						<div class="cenImg" v-for="i in third_aList" :key="i.id">
							<el-image :src="i.img" :preview-src-list="Imgs">
							</el-image>
							<div class="txt">{{i.title}}</div>
						</div>
					</div>
				</div>
				<div class="ACCSBox" v-if="softList.length >0">
					<div class="two1">
						计算机软件著作权登记
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						COPYRIGHT
					</div>
					<div class="ACCSImg">
						<div class="cenImg" v-for="i in softList" :key="i.id">
							<el-image :src="i.img" :preview-src-list="Imgss">
							</el-image>
							<div class="txt">{{i.title}}</div>
						</div>
					</div>
				</div>
				<div class="otherBox" v-if="otherList.length >0">
					<div class="two1">
						其他荣誉
					</div>
					<div class="two2">
						<div class="two22"></div>
						<div class="two21"></div>
						<div class="two23"></div>
					</div>
					<div class="two3">
						OTHER HONORS
					</div>
					<div class="otherImg">
						<div class="cenImg" v-for="i in otherList" :key="i.id">
							<el-image :src="i.img" :preview-src-list="Imgsss">
							</el-image>
							<div class="txt">{{i.title}}</div>
						</div>
					</div>
				</div>
			</div>
			<dibu></dibu>
		</div>
		<div class="crestBox pointer" @click="crestCick()" v-if="isVisable == true">
			<img src="../../assets/img/return.svg" />
		</div>
	</div>
</template>

<script>
	import Toubu from "@/components/header.vue";
	import Dibu from "@/components/footer.vue";
	import {
		Message
	} from "element-ui";
	export default {
		data() {
			return {
				technologyImg:[
					'http://qiniu.boruankeji.net/6821bde60d0756f874e88648607659e1.png'
				],
				CMMIImg:[
					'http://qiniu.boruankeji.net/dcd68a9231fd4abda479781b54b1f076.png'
				],
				ITSSImg:[
					'http://qiniu.boruankeji.net/2b23e38799cf5036b730b474ad8a64dd.png',
					'http://qiniu.boruankeji.net/369c919d1c5ee7295bfbeca5a9dce6a7.png'
				],
				ISOImg:[
					'http://qiniu.boruankeji.net/b52f7c8f78d6895216231a1a897cf331.png',
					'http://qiniu.boruankeji.net/67adb94bcaee4146182dbf5e4fddc251.png'
				],
				isVisable: false,
				isMobile: this.$store.state.isMobile === 1,
				tableData: [],
				dialogVisible: false,
				form: {},
				imgurl: "",
				id: "",
				recruitInfo: {},
				srcList: [],
				Img: [],
				third_aList: [],
				Imgs: [],
				softList: [],
				Imgss: [],
				otherList: [],
				Imgsss: [],
			};
		},
		components: {
			Toubu,
			Dibu
		},
		computed: {},
		mounted() {
			//获取职位
			this.$post(this.$host + "/index/Home/companyHonor").then((res) => {
				this.srcList = res.data.management;
				var images = [];
				for (var j = 0; j < res.data.management.length; j++) {
					images.push(res.data.management[j].img)
				}
				this.Img = images

				this.third_aList = res.data.third_a;
				var Imgs = [];
				for (var j = 0; j < res.data.third_a.length; j++) {
					Imgs.push(res.data.third_a[j].img)
				}
				this.Imgs = Imgs

				this.softList = res.data.soft;
				var Imgss = [];
				for (var j = 0; j < res.data.soft.length; j++) {
					Imgss.push(res.data.soft[j].img)
				}
				this.Imgss = Imgss

				this.otherList = res.data.other;
				var Imgsss = [];
				for (var j = 0; j < res.data.other.length; j++) {
					Imgsss.push(res.data.other[j].img)
				}
				this.Imgsss = Imgsss

			});
		},
		created() {
			//添加滚动监听事件
			//在窗口滚动时调用监听窗口滚动方法
			window.addEventListener('scroll', this.windowScrollListener);
		},
		destroyed() {
			//离开页面时删除该监听
			window.removeEventListener('scroll', this.windowScrollListener)
		},
		methods: {
			//监听窗口滚动
			windowScrollListener() {
				//获取操作元素最顶端到页面顶端的垂直距离
				var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
				if (scrollTop >= 1500) {
					this.isVisable = true; //大于1500时显示元素
				}
				if (scrollTop < 1500) {
					this.isVisable = false; //小于1500时隐藏元素
				}
			},
			crestCick() {
				//让页面滚动回到顶部
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
			getBack() {
				window.history.go(-1);
			},
		},
	};
</script>

<style lang="scss" scoped>
	/deep/.el-image-viewer__wrapper {
		z-index: 9999999991 !important;
	}

	/deep/.el-icon-circle-close:before {
		color: #fff;
	}

	.two {
		width: 100vw;
		padding-bottom: 104px;

		.imgBg {
			width: 100vw;
		}
		.technologyBox{
			
			width: 1300px;
			margin: 0 auto;
		
			.technologyImg {
				margin-top: 60px;
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				
				.cenImg {
					display: flex;
					align-items: center;
					width: 859px;
					margin-bottom: 80px;
		
					/deep/.el-image {
						width: 100%;
						box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
						// height: 588px;
						// border: 1px solid #999999;
					}
		
					.txt {
						margin-top: 30px;
						// line-height: 50px;
						font-size: 24px;
						color: #222222;
						text-align: center;
					}
				}
				
			}
		
			
		}

		.ITSSBox{
			width: 1300px;
			margin: 0 auto;
			// background: red;
		
			.ITSSImg {
				margin-top: 60px;
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
		
				.cenImg {
					display: flex;
					align-items: center;
					width: 635px;
					margin-bottom: 80px;
		
					/deep/.el-image {
						width: 100%;
						box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
						// height: 588px;
						// border: 1px solid #999999;
					}
		
					.txt {
						margin-top: 30px;
						// line-height: 50px;
						font-size: 24px;
						color: #222222;
						text-align: center;
					}
				}
				.cenImgone{
					margin-right: 27px;
				}
			}
		}

		.ISOBox{
			width: 1300px;
			margin: 0 auto;
			// background: red;
		
			.ISOImg {
				margin-top: 60px;
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
		
				.cenImg {
					display: flex;
					align-items: center;
					flex-direction: column;
					width: 408px;
					margin-bottom: 80px;
		
					/deep/.el-image {
						width: 100%;
						// height: 588px;
						// border: 1px solid #999999;
						box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
					}
		
					.txt {
						margin-top: 30px;
						// line-height: 50px;
						font-size: 24px;
						color: #222222;
						text-align: center;
					}
				}
				.cenImgone{
					margin-right: 27px;
				}
			}
		}
		
		
		.managementBox {
			width: 1320px;
			margin: 0 auto;
			// background: red;

			.managementImg {
				margin-top: 60px;
				display: flex;
				flex-wrap: wrap;

				.cenImg {
					width: 408px;
					margin-left: 16px;
					margin-right: 16px;
					margin-bottom: 80px;

					/deep/.el-image {
						width: 408px;
						height: 570px;
						box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
						// border: 1px solid #999999;
					}

					.txt {
						margin-top: 30px;
						// line-height: 50px;
						font-size: 24px;
						color: #222222;
						text-align: center;
					}
				}
			}

		}

		.certificateBox {
			width: 1320px;
			margin: 0 auto;
			// background: red;

			.certificateImg {
				margin-top: 60px;
				display: flex;
				flex-wrap: wrap;

				.cenImg {
					width: 408px;
					margin-left: 16px;
					margin-right: 16px;
					margin-bottom: 80px;

					/deep/.el-image {
						width: 408px;
						height: 292px;
						box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
						// border: 1px solid #999999;
					}

					.txt {
						margin-top: 30px;
						// line-height: 50px;
						font-size: 24px;
						color: #222222;
						text-align: center;
					}
				}
			}

		}

		.otherBox {
			width: 1320px;
			margin: 0 auto;
			// background: red;
			
			.otherImg {
				margin-top: 60px;
				display: flex;
				flex-wrap: wrap;
			
				.cenImg {
					width: 408px;
					margin-left: 16px;
					margin-right: 16px;
					margin-bottom: 80px;
			
					/deep/.el-image {
						width: 408px;
						height: 292px;
						box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
						// border: 1px solid #999999;
					}
			
					.txt {
						margin-top: 30px;
						// line-height: 50px;
						font-size: 24px;
						color: #222222;
						text-align: center;
					}
				}
			}
			
		}

		.ACCSBox {
			width: 1320px;
			margin: 0 auto;
			// background: red;
			
			.ACCSImg {
				margin-top: 60px;
				display: flex;
				flex-wrap: wrap;
			
				.cenImg {
					width: 408px;
					margin-left: 16px;
					margin-right: 16px;
					margin-bottom: 80px;
			
					/deep/.el-image {
						width: 408px;
						height: 570px;
						box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
						// border: 1px solid #999999;
					}
			
					.txt {
						margin-top: 30px;
						// line-height: 50px;
						font-size: 24px;
						color: #222222;
						text-align: center;
					}
				}
			}
			
		}

		.getBack {
			width: 1300px;
			margin: 0 auto;
			margin-top: 49px;
			display: flex;
			align-items: center;
			cursor: pointer;

			img {
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}

			div {
				font-size: 24px;
				color: #999999;

				span {
					color: #126CE7;
				}
			}
		}

		.two1 {
			text-align: center;
			font-size: 40px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			padding-top: 59px;
			padding-bottom: 23px;
			// margin-top: 59px;
		}

		.two2 {
			display: flex;
			justify-content: center;

			.two22 {
				width: 180px;
				height: 1px;
				background: rgba(128, 128, 128, 0.616);
				margin-right: 1vw;
			}

			.two21 {
				width: 40px;
				height: 3px;
				background: #ffae67;
			}

			.two23 {
				width: 180px;
				height: 1px;
				background: rgba(128, 128, 128, 0.616);
				margin-left: 1vw;
			}
		}

		.two3 {
			margin-top: 24px;
			display: flex;
			justify-content: center;
			color: rgba(0, 0, 0, 0.418);
			font-size: 30px;
			font-weight: 400;
			color: #999999;
		}

		.two4 {
			margin-top: 68px;

			.nullBox {
				width: 500px;
				margin: 0 auto;
				margin-top: 50px;

				img {
					margin: 0 auto;
				}
			}

			.cenMain {
				// background: indianred;
				width: 67vw;
				display: flex;
				flex-direction: column;
				justify-content: center;
				height: 150px;
				margin: 0 auto;
				position: relative;

				.title {
					font-size: 24px;
					color: #222222;
					margin-bottom: 27px;
					margin-left: 39px;
				}

				.info {
					font-size: 22px;
					color: #7F8393;
					margin-left: 39px;

					span {
						margin-right: 38px;
					}
				}

				.application {
					width: 120px;
					height: 50px;
					line-height: 50px;
					border-radius: 25px;
					text-align: center;
					font-size: 22px;
					color: #2276F5;
					position: absolute;
					right: 39px;
					top: 55px;
					cursor: pointer;
				}
			}

			.cenMain:hover {
				background: url(../../assets/chenggong/listBg.png);
				background-size: 100% 100%;
				box-shadow: 0px 0px 20px 0px rgba(153, 153, 153, 0.2);

				.application {
					color: #fff;
					background: #126CE7;
					border-radius: 25px;
				}
			}



			.two41 {
				margin-left: 15vw;
				margin-top: 51px;

				td {
					height: 100px;
				}

				/deep/.el-table {}

				/deep/.el-table__body tr:hover>td {
					color: #126ce7;
					background: #e9f3ff;
				}

				/deep/.el-table__body tr:hover>* {
					color: #126ce7;
					background: #e9f3ff;
				}
			}
		}
	}
</style>
